import React, { useEffect } from 'react';
import { Button, Result } from 'antd';
import { PageProps } from '../lib/pageProps';
import Loading from '../../../components/base/Loading';
import { useCheckPaymentQuery } from '../../../graphql/schema';
import { Page } from '../lib/pageEnum';

const PaymentPage = ({ navigate }: PageProps) => {
  const orderIdMatch = window.location.search.match(/orderId=([0-9]+)/);
  const orderId = orderIdMatch ? parseInt(orderIdMatch[1], 10) : 0;

  const { loading, data, refetch } = useCheckPaymentQuery({
    variables: {
      orderId,
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (data?.checkPayment.status === 'pending') {
      const handle = setInterval(() => {
        refetch();
      }, 1000 * 5);
      return () => {
        clearInterval(handle);
      };
    }
    return () => {};
  }, [data]);

  if (loading) return <Loading />;

  return (
    <div>
      {data?.checkPayment.status === 'paid' && (
        <Result
          status="success"
          title="Willkommen an Bord & vielen Dank für Deine Buchung!"
          subTitle={
            <div>
              Wir melden uns in Kürze bei Dir mit weiteren Informationen.
              <br />
              Wenn Du in der Zwischenzeit Fragen hast, melde Dich gerne jederzeit bei uns!
            </div>
          }
        />
      )}
      {data?.checkPayment.status === 'pending' && (
        <Result
          status="warning"
          title="Zahlung in Bearbeitung..."
          subTitle={
            <div>
              Deine Zahlung ist noch in Bearbeitung. Bitte warte kurz, bis wir Deine Zahlung
              erhalten haben.
            </div>
          }
          extra={
            <Button
              type="primary"
              onClick={() => {
                refetch();
              }}
            >
              Aktualisieren
            </Button>
          }
        />
      )}
      {data?.checkPayment.status === 'failed' && (
        <Result
          status="error"
          title="Fehler bei der Bezahlung"
          subTitle={
            <div>
              Leider ist ein Fehler bei der Bezahlung aufgetreten. Bitte versuche es noch einmal.
              <br />
              Sollte die Bezahlung weiterhin nicht klappen, melde Dich bitte bei uns.
            </div>
          }
          extra={
            <Button
              type="primary"
              onClick={() => {
                navigate(Page.checkout);
              }}
            >
              Zu Deiner Buchung
            </Button>
          }
        />
      )}
    </div>
  );
};
export default PaymentPage;
